import { gql } from '@apollo/client';

export const GET_PORTFOLIOS = gql`
  query PRODUCT_SERVICE_V2_getPortfolios($request: PortfolioRequest!) {
    getPortfolios(request: $request) {
      id
      rateSegment
      name
      productLineId
      products {
        imProductId
        productLine
        productDisplayName
        carrier {
          id
          name
          logo
        }
        bcDependentData
      }
      marketingTagIds
      bcVersions
      advantages
      configurable
      eStoreTagId
    }
  }
`;

export const GET_PORTFOLIOS_BY_ID = gql`
  query PRODUCT_SERVICE_V2_getPortfoliosByIdWithBC($cartItems: [CartItem!]!, $lastUpdateBC: Map) {
    getPortfoliosByIdWithBC(cartItems: $cartItems, lastUpdateBC: $lastUpdateBC) {
      id
      rateSegment
      name
      productLineId
      products {
        imProductId
        productLine
        productDisplayName
        carrier {
          id
          name
          logo
        }
        bcDependentData
      }
      marketingTagIds
      bcVersions
      advantages
      configurable
      eStoreTagId
    }
  }
`;

export const GET_CATALOG = gql`
  query PRODUCT_SERVICE_V2_getCatalog(
    $domainId: ID!
    $effectiveDate: String
    $rateSegment: RateSegment
    $state: String
  ) {
    getCatalog(domainId: $domainId, effectiveDate: $effectiveDate, rateSegment: $rateSegment, state: $state) {
      id
      rateSegment
      productLineAttributes {
        id
        displayName
        planTile
        link
        hidden
        disclaimer
        productLine
        type
        category
        properties
      }
      marketingTags {
        id
        tag
        productLines
      }
      eStoreFilters {
        type
        key
        productLines
        filters {
          value
          displayName
        }
      }
    }
  }
`;
